import {
  Box,
  Button,
  Collapse,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  bgColor07,
  bgColor15,
  blackColor,
  blackShade05,
  blackShade19,
  blueColor04,
  greenStatusColor01,
  greyColor060,
  greyShade01,
  greyShade07,
  heroSectionText,
  lightBlueColor01,
  lightgreenColor04,
  oldPriceColor,
  orangeStatusColor,
  outOfStockColor,
  primaryColor,
  redColor09,
  redStatusColor01,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import moment from "moment";
import {
  getShipingLabelLink,
  resendInvoiceApi,
  resendInvoiceApiB2B,
} from "../../../service/api_calls/orders/OrdersApi";
import {
  getDiscountPercentage,
  getOrderType,
  updateApproveList,
} from "../../../utils/helper";
import { getCartInfoApi } from "../../../service/api_calls/grievance/grievanceApi";
import { textOneLines, textTwoLines } from "../../../utils/styles";
import LightToolTip from "../../../components/Alerts/LightToolTip";

function ProductDetailsOrderReport({ item, openRow }) {
  const isOpen = openRow === item.orderId;

  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [cartInfo, setCartInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [steps, setSteps] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successB2B, setSuccessB2B] = useState(false);
  const [errorB2B, setErrorB2B] = useState(false);
  const [loadingB2B, setLoadingB2B] = useState(false);
  const [loadingLabel, setLoadingLabel] = useState(false);
  const [errorLabel, setErrorLabel] = useState(false);

  const orderType = getOrderType(item);

  const getCartData = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    setLoading(true);

    if (item?.cartId) {
      console.log("ORDER_DATA", item);
      const response = await getCartInfoApi({
        cartId: item?.cartId,
        businessId,
      });

      if (response?.cart) {
        setCartInfo(response?.cart || null);
        setLoading(false);
        setSteps(updateApproveList(response?.cart));
        setSuccess(false);
        setSuccessB2B(false);
        return;
      }
    }

    setLoading(false);
  };

  const getBGColorByStatus = (status) => {
    switch (status) {
      case "ordercreated":
        return orangeStatusColor;
      case "orderapproved":
        return blackShade05;
      case "ordershipped":
        return lightBlueColor01;
      case "orderdelivered":
        return lightBlueColor01;
      case "bordercanceled":
      case "cordercanceled":
      case "lordercanceled":
        return outOfStockColor;

      default:
        return "";
    }
  };
  const getText = (status) => {
    switch (status) {
      case "bordercanceled":
        return "Canceled by Business";
      case "cordercanceled":
        return "Canceled by Customer";
      case "lordercanceled":
        return "Canceled by Logistics";

      default:
        return "";
    }
  };

  // Get Cancel Date by status
  const getCancelDateByStatus = (orderInfo) => {
    const orderStatus = orderInfo?.orderStatus || "";

    switch (orderStatus) {
      case "bordercanceled":
        return orderInfo?.orderCancelDateBusiness
          ? moment(orderInfo?.orderCancelDateBusiness)?.format(
              "Do MMM, YYYY hh:mm A"
            )
          : "N/A";

      case "cordercanceled":
        return orderInfo?.orderCancelDateConsumer
          ? moment(orderInfo?.orderCancelDateConsumer)?.format(
              "Do MMM, YYYY hh:mm A"
            )
          : "N/A";

      case "lordercanceled":
        return orderInfo?.orderCancelDateLogistic
          ? moment(orderInfo?.orderCancelDateLogistic)?.format(
              "Do MMM, YYYY hh:mm A"
            )
          : "N/A";

      default:
        return "N/A";
    }
  };

  const getOrderStatusText = (status) => {
    switch (status) {
      case "ordercreated":
        return "Pending";
      case "orderapproved":
        return "Approved";
      case "ordershipped":
        return "Shipped";
      case "orderdelivered":
        return "Completed";
      case "bordercanceled":
        return "Canceled";
      case "cordercanceled":
        return "Canceled";
      case "lordercanceled":
        return "Canceled";

      default:
        return "";
    }
  };

  const handleResend = async () => {
    if (item?.cartId) {
      const response = await resendInvoiceApi({
        cartId: item?.cartId,
      });

      if (response) {
        setSuccess(true);
        return;
      }
    }
  };

  const handleResendB2B = async () => {
    setErrorB2B(false);
    setSuccessB2B(false);
    setLoadingB2B(false);
    if (item?.cartId) {
      if (
        cartInfo?.shipmentInfo?.carrierTrackId?.length === 36 ||
        !cartInfo?.shipmentInfo?.carrierTrackId
      ) {
        setErrorB2B(true);
        return;
      }
      setLoadingB2B(true);

      const businessId = sessionStorage.getItem("selectedBusinessId");
      const response = await resendInvoiceApiB2B({
        cartId: item?.cartId,
        carrierId: cartInfo?.shipmentInfo?.carrierTrackId,
        businessId,
      });

      if (response) {
        setSuccessB2B(true);
        setLoadingB2B(false);
        return;
      }
    }
  };

  const downloadShipingLabel = async () => {
    setErrorLabel(false);
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const data = { businessId, wbns: cartInfo?.shipmentInfo?.carrierTrackId };
    setLoadingLabel(true);
    const shipingLabelLink = await getShipingLabelLink(data);
    setLoadingLabel(false);
    console.log("downloadPdf", shipingLabelLink);
    if (!shipingLabelLink?.packages?.[0]?.pdf_download_link) {
      setErrorLabel(true);
      return;
    }
    downloadPdf(
      shipingLabelLink?.packages?.[0]?.pdf_download_link,
      "shippingLabel.pdf"
    );
  };

  const downloadPdf = (url, name) => {
    console.log(url, name);
    window.open(url, "_self");
    // const link = document.createElement("a");
    // link.href = { url }; // Replace with the path to your PDF file
    // link.download = name; // The name of the downloaded file
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // fetch(url, { method: "HEAD" })
    //   .then((response) => {
    //     if (response.ok) {
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.download = name; // The name of the downloaded file
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //     } else {
    //       alert("File wasn't available on site");
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching the PDF:", error);
    //     alert("An error occurred while trying to fetch the PDF");
    //   });
  };

  useEffect(() => {
    getCartData();
    return () => {};
  }, []);

  return (
    cartInfo && (
      // <TableRow>
      //   <TableCell colSpan={12} style={{ padding: 0 }}>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box sx={{ padding: 0, backgroundColor: bgColor07 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={1.5}>
              <InputPreview
                label={"Contact No"}
                value={cartInfo?.customerAddress?.phoneNo}
              />
            </Grid>
            <Grid item xs={6} md={4.2}>
              <LightToolTip
                title={`${
                  cartInfo?.customerAddress?.houseNo
                    ? `${cartInfo?.customerAddress?.houseNo},`
                    : ""
                } ${
                  cartInfo?.customerAddress?.city
                    ? `${cartInfo?.customerAddress?.city},`
                    : ""
                }${
                  cartInfo?.customerAddress?.state
                    ? `${cartInfo?.customerAddress?.state},`
                    : ""
                }- ${cartInfo?.customerAddress?.zip}.`}
                placement="top"
              >
                <InputPreview
                  label={"Address"}
                  value={`${
                    cartInfo?.customerAddress?.houseNo
                      ? `${cartInfo?.customerAddress?.houseNo},`
                      : ""
                  } ${
                    cartInfo?.customerAddress?.city
                      ? `${cartInfo?.customerAddress?.city},`
                      : ""
                  }${
                    cartInfo?.customerAddress?.state
                      ? `${cartInfo?.customerAddress?.state},`
                      : ""
                  }- ${cartInfo?.customerAddress?.zip}`}
                  valueStyles={{ width: "350px", ...textOneLines }}
                />
              </LightToolTip>
            </Grid>{" "}
            {/* <Grid item xs={6} md={1.2}>
              <InputPreview
                label={"Delivery Date"}
                value={
                  cartInfo?.orderDeliveredOn
                    ? moment(cartInfo?.orderDeliveredOn).format("DD MMM, yyyy ")
                    : "-"
                }
              />
            </Grid> */}
            <Grid item xs={6} md={1.8}>
              <InputPreview
                label={"Total Qty"}
                value={cartInfo?.totalQuantity}
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <InputPreview
                label={"Product Total"}
                value={`₹ ${cartInfo?.orderTotalProductCost}`}
              />

              {/* {cartInfo?.orderDeliveredOn && ( */}
            </Grid>
            <Grid item xs={12} md={1.75}>
              <InputPreview
                label={"Ship. Cost"}
                value={`₹ ${cartInfo?.shippingCost}`}
              />
            </Grid>
            <Grid item xs={12} md={1.5}>
              <InputPreview
                label={"Discount"}
                value={
                  // cartInfo?.discountDetails?.[0]?.discountAmount > 0
                  //   ? `₹ ${cartInfo?.discountDetails?.[0]?.discountAmount}`
                  //   : "XXX"
                  <Box display={"flex"}>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        color:
                          item?.discountDetails?.[0]?.discountAmount > 0
                            ? greenStatusColor01
                            : redStatusColor01,
                        textAlign: "center",
                        backgroundColor:
                          item?.discountDetails?.[0]?.discountAmount > 0
                            ? lightgreenColor04
                            : redColor09,
                        padding: "2px 4px",
                        // width: "60px",
                        borderRadius: "4px",
                      }}
                    >
                      {item?.discountDetails?.[0]?.discountAmount > 0
                        ? `₹ ${item?.discountDetails?.[0]?.discountAmount}`
                        : "XXX"}
                    </Box>
                  </Box>
                }
              />
            </Grid>
          </Grid>

          <Box
            //   key={index}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              // alignItems: "center",
              background: "#fff",
              width: "100%",
              // margin: "0px auto",
              padding: "15px 5px 15px 0px",
              borderRadius: "10px",
              border: "1px solid #e9ebf5",
              flexDirection: "column",
              position: "relative",
            }}
            mt={1}
          >
            <Box
              sx={{
                top: "0px",
                left: "48%",
                background: "#cdd5e5",
                padding: "0px 12px",
                lineHeight: "16px",
                borderRadius: "0px 0px 6px 6px",
                color: "#061024",
                fontWeight: 400,
                fontSize: "10.5px",
                position: " absolute",
              }}
            >
              Tax Rate
            </Box>
            <Box
              sx={{
                top: "0px",
                left: "63.5%",
                background: "#cdd5e5",
                padding: "0px 12px",
                lineHeight: "16px",
                borderRadius: "0px 0px 6px 6px",
                color: "#061024",
                fontWeight: 400,
                fontSize: "10.5px",
                position: " absolute",
              }}
            >
              Qty
            </Box>
            <Box
              padding={"15px"}
              pb={0}
              height={cartInfo?.productList?.length > 2 ? "125px" : "auto"}
              sx={{
                overflowY:
                  cartInfo?.productList?.length > 2 ? "scroll" : "auto", // Enable vertical scrolling when needed
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#e5e9f0",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {/* cartInfo?.map */}
              {cartInfo?.productList?.map((item, index) => {
                return (
                  <Grid
                    key={index}
                    container
                    spacing={1}
                    alignItems={"center"}
                    borderBottom={
                      index < cartInfo?.productList?.length - 1
                        ? `1px solid #e9ebf5`
                        : ""
                    }
                    pb={!index ? 1 : 1}
                    mb={!index ? 1 : 1}
                  >
                    <Grid item md={0.7}>
                      <Box
                        sx={{
                          position: "relative",
                          width: "40px",
                          height: "40px",
                          padding: "3px",
                          backgroundColor: "#ffffff",
                          alignItems: "center",
                          textAlign: "center",
                          borderRadius: "5px",
                          border: "1px solid #e5e9f0",
                          marginRight: "12px",
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Box
                          component="img"
                          maxHeight={{ xs: "29px", md: "40px" }}
                          src={item?.productPicURL}
                          alt="CostBo"
                        />
                      </Box>
                    </Grid>
                    <Grid item md={5.1}>
                      <Typography
                        variant="h3"
                        fontSize={{ xs: 12, md: 12 }}
                        color={blackShade19}
                        fontWeight={600}
                        lineHeight={1.5}
                      >
                        {item?.productName}
                      </Typography>
                    </Grid>
                    <Grid item md={1.9}>
                      <Typography
                        variant="h3"
                        fontSize={{ xs: 12, md: 12 }}
                        color={blackShade19}
                        fontWeight={600}
                        lineHeight={1.5}
                      >
                        {item?.productTaxRate} %
                      </Typography>
                    </Grid>
                    <Grid item md={1}>
                      <Box>
                        <Typography
                          variant="h3"
                          fontSize={{ xs: 12, md: 12 }}
                          color={blackShade19}
                          fontWeight={600}
                          lineHeight={1.5}
                        >
                          {item?.originalQuantity}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item md={3}>
                      <Box
                        display={"flex"}
                        justifyContent={
                          // item?.productOriginalPrice === item?.productSalePrice
                          //   ?
                          "start"
                          // : "space-between"
                        }
                        flexDirection={"row"}
                        gap={1.5}
                      >
                        {item?.productOriginalPrice !==
                          item?.productSalePrice && (
                          <Typography
                            variant="body1"
                            color={bgColor15}
                            fontSize={12}
                            lineHeight="15px"
                            fontWeight={400}
                            mt={{
                              xs: "0px !important",
                              md: "7px !important",
                            }}
                            sx={{
                              display: "inline",
                              textDecoration: "line-through",
                            }}
                          >
                            {item?.productOriginalPrice ===
                            item?.productSalePrice
                              ? ""
                              : `₹ ${item?.productOriginalPrice}`}
                          </Typography>
                        )}

                        <Typography
                          variant="body1"
                          color={blackShade19}
                          fontSize={12}
                          lineHeight="15px"
                          fontWeight={600}
                          m="6px 0 0 0px"
                          sx={{
                            display: "inline",
                            // ml:
                            //   item?.productOriginalPrice ===
                            //   item?.productSalePrice
                            //     ? 0
                            //     : 1,
                            // mr: 1,
                          }}
                        >
                          ₹ {item?.productSalePrice}
                        </Typography>
                        {item?.productOriginalPrice !==
                          item?.productSalePrice && (
                          <Box
                            sx={{
                              fontWeight: 500,
                              fontSize: "12px",
                              color:
                                item?.percentageOff > 0
                                  ? greenStatusColor01
                                  : redStatusColor01,
                              textAlign: "center",
                              backgroundColor:
                                item?.percentageOff > 0
                                  ? lightgreenColor04
                                  : redColor09,
                              padding: "2px 4px",
                              width: "40px",
                              borderRadius: "4px",
                            }}
                          >
                            {item?.productOriginalPrice !==
                            item?.productSalePrice
                              ? `${getDiscountPercentage(
                                  item?.productSalePrice,
                                  item?.productOriginalPrice
                                )} %`
                              : "XXX"}
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Collapse>
      //   </TableCell>
      // </TableRow>
    )
  );
}

export default ProductDetailsOrderReport;

function InputPreview({
  label,
  value,
  infoText,
  labelSize,
  valueSize,
  styles,
  valueStyles,
  isReadMoreLess,
  hideBorder,
  hideLabel,
}) {
  const [showMore, setShowMore] = useState(false);
  const charLimit = 120;

  return (
    <Box sx={inputBox(hideBorder)}>
      {!hideLabel ? (
        <Typography
          variant="h3"
          fontSize={{ xs: 12, md: labelSize || 11.5 }}
          color={bgColor15}
          fontWeight={400}
          lineHeight={1.5}
          mb={{
            xs: labelSize ? "0px !important" : "4px !important",
            md: labelSize ? "0px !important" : "2px !important",
          }}
          sx={{ ...styles }}
        >
          {label}{" "}
          <span style={{ fontSize: "11.5px", color: bgColor15 }}>
            {infoText}
          </span>
        </Typography>
      ) : (
        <Box sx={{ height: "22px" }} />
      )}

      <Typography
        variant="body1"
        fontSize={{ xs: 12, md: valueSize || 12 }}
        color={blackShade19}
        fontWeight={600}
        minHeight={{ md: "28px", xs: "24px" }}
        sx={{ textAlign: "justify", ...valueStyles }}
      >
        {isReadMoreLess
          ? showMore
            ? value
            : value?.slice(0, charLimit)
          : value || "-"}

        {isReadMoreLess && (
          <span>
            {value?.length > charLimit && (
              <Button
                onClick={() => {
                  setShowMore(!showMore);
                }}
                sx={readBtn}
              >
                {showMore ? "Read less" : "Read more"}
              </Button>
            )}
          </span>
        )}
      </Typography>
    </Box>
  );
}

const inputBox = (hideBorder) => ({
  // width:"130px",
  pb: { md: 0, xs: 0 },
  //   borderBottom: hideBorder ? "none" : border27,
  backgroundColor: bgColor07,
});

const readBtn = {
  fontSize: 12,
  fontWeight: 500,
  color: primaryColor,
  textTransform: "unset",
  textDecoration: "underline",
  padding: "0px",
  ml: 0.5,
};

const styles = {
  section: {
    p: "10px 20px 20px 20px",
    backgroundColor: whiteColor,
    boxShadow: "0 0px 4px 0 rgb(0 0 0 / 5%)",
    borderRadius: "10px",
  },
  statusChip: (data) => ({
    backgroundColor: data.bgColor,
    color: data.color,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.5,
    p: "3px 13px",
    borderRadius: "50px",
    width: "max-content",
  }),
  imgLogo: {
    width: "auto",
    height: "130px",
    border: `1.5px solid ${greyShade07}`,
    objectFit: "contain",
    borderRadius: "15px",
  },
  img: {
    width: "auto",
    height: "130px",
    border: `1.5px solid ${greyShade07}`,
    objectFit: "contain",
    borderRadius: "15px",
  },
};
